import includes from 'lodash/includes';
export const MOBILE_PUSH_LIVE_ACTIVITY_START_MAX_ATTEMPTS = 5;
export const EE_SCHEDULER_TASKS = {
    SLACK_AI_PROMPT: 'slackAiPrompt',
    SLACK_AI_ARTIFACT_IMAGES: 'slackAiArtifactImages',
    SWEEP_SLACK_AI_ARTIFACT_IMAGES: 'sweepSlackAiArtifactImages',
    AI_AGENT_EVAL_RESULT: 'aiAgentEvalResult',
    AI_AGENT_REVIEW_CLASSIFIER: 'aiAgentReviewClassifier',
    AI_AGENT_REVIEW_WRITEBACK: 'aiAgentReviewWriteback',
    AI_AGENT_REVIEW_REMEDIATION_PREVIEW: 'aiAgentReviewRemediationPreview',
    AI_AGENT_REVIEW_REMEDIATION_COMPILE: 'aiAgentReviewRemediationCompile',
    AI_AGENT_REVIEW_REMEDIATION_RUN: 'aiAgentReviewRemediationRun',
    SEND_REVIEW_NOTIFICATION: 'sendReviewNotification',
    SEND_CONTENT_REVIEW_NOTIFICATION: 'sendContentReviewNotification',
    CREATE_REVIEW_JIRA_ISSUE: 'createReviewJiraIssue',
    CREATE_REVIEW_LINEAR_ISSUE: 'createReviewLinearIssue',
    EMBED_ARTIFACT_VERSION: 'embedArtifactVersion',
    GENERATE_ARTIFACT_QUESTION: 'generateArtifactQuestion',
    APP_GENERATE_PIPELINE: 'appGeneratePipeline',
    APP_BUILD_FROM_SOURCE: 'appBuildFromSource',
    APP_CAPTURE_THUMBNAIL: 'appCaptureThumbnail',
    AI_WRITEBACK_PIPELINE: 'aiWritebackPipeline',
    AI_DEEP_RESEARCH: 'aiDeepResearch',
    DATA_APP_INVESTIGATE: 'dataAppInvestigate',
    AGENT_ONBOARDING_RUN: 'agentOnboardingRun',
    AI_AGENT_EDIT_DBT_PROJECT_PIPELINE: 'aiAgentEditDbtProjectPipeline',
    SWEEP_STALE_APP_LOCKS: 'sweepStaleAppLocks',
    SWEEP_STALE_AI_WRITEBACK_RUNS: 'sweepStaleAiWritebackRuns',
    SWEEP_STALE_AI_DEEP_RESEARCH_RUNS: 'sweepStaleAiDeepResearchRuns',
    SWEEP_STALE_AI_EVAL_RUNS: 'sweepStaleAiEvalRuns',
    SWEEP_AI_AGENT_MEMORY_THREADS: 'sweepAiAgentMemoryThreads',
    AI_AGENT_MEMORY_DISTILL: 'aiAgentMemoryDistill',
    CONSOLIDATE_AI_AGENT_MEMORIES: 'consolidateAiAgentMemories',
    CONSOLIDATE_AI_AGENT_MEMORY_PARTITION: 'consolidateAiAgentMemoryPartition',
    CLEAN_MCP_TOOL_CALLS: 'cleanMcpToolCalls',
    CLEAN_RATE_COUNTERS: 'cleanRateCounters',
    CLEAN_DATA_APP_ANALYSES: 'cleanDataAppAnalyses',
    CLEAN_AI_DEEP_RESEARCH_REPORTS: 'cleanAiDeepResearchReports',
    CLEAN_AI_AGENT_THREADS: 'cleanAiAgentThreads',
    CLEAN_SCIM_REQUEST_LOGS: 'cleanScimRequestLogs',
    PUBLISH_ANNOUNCEMENT: 'publishAnnouncement',
    SWEEP_DUE_ANNOUNCEMENTS: 'sweepDueAnnouncements',
    SEND_AI_CREDIT_ALLOWANCE_ALERTS: 'sendAiCreditAllowanceAlerts',
    INGEST_EXTERNAL_SOURCE: 'ingestExternalSource',
    INGEST_EXTERNAL_SOURCE_ATTACHMENT: 'ingestExternalSourceAttachment',
    MAINTAIN_EXTERNAL_SOURCES: 'maintainExternalSources',
    SWEEP_UNCLAIMED_AI_THREAD_FILES: 'sweepUnclaimedAiThreadFiles',
    MOBILE_PUSH_LIVE_ACTIVITY_START: 'mobilePushLiveActivityStart',
    MOBILE_PUSH_LIVE_ACTIVITY: 'mobilePushLiveActivity',
    SWEEP_MOBILE_PUSH_LIVE_ACTIVITIES: 'sweepMobilePushLiveActivities',
};
export const SCHEDULER_TASKS = {
    HANDLE_SCHEDULED_DELIVERY: 'handleScheduledDelivery',
    // Legacy individual notification tasks (deprecated, kept for backwards compatibility)
    SEND_SLACK_NOTIFICATION: 'sendSlackNotification',
    SEND_EMAIL_NOTIFICATION: 'sendEmailNotification',
    SEND_MSTEAMS_NOTIFICATION: 'sendMsTeamsNotification',
    SEND_GOOGLE_CHAT_NOTIFICATION: 'sendGoogleChatNotification',
    // Batch notification tasks - one job per delivery type
    SEND_SLACK_BATCH_NOTIFICATION: 'sendSlackBatchNotification',
    SEND_EMAIL_BATCH_NOTIFICATION: 'sendEmailBatchNotification',
    SEND_MSTEAMS_BATCH_NOTIFICATION: 'sendMsTeamsBatchNotification',
    SEND_GOOGLE_CHAT_BATCH_NOTIFICATION: 'sendGoogleChatBatchNotification',
    UPLOAD_GSHEETS: 'uploadGsheets',
    UPLOAD_GSHEET_FROM_QUERY: 'uploadGsheetFromQuery',
    VALIDATE_PROJECT: 'validateProject',
    COMPILE_PROJECT: 'compileProject',
    COPY_PREVIEW_CONTENT: 'copyPreviewContent',
    CREATE_PROJECT_WITH_COMPILE: 'createProjectWithCompile',
    TEST_AND_COMPILE_PROJECT: 'testAndCompileProject',
    SQL_RUNNER: 'sqlRunner',
    SQL_RUNNER_PIVOT_QUERY: 'sqlRunnerPivotQuery',
    REPLACE_CUSTOM_FIELDS: 'replaceCustomFields',
    INDEX_CATALOG: 'indexCatalog',
    GENERATE_DAILY_JOBS: 'generateDailyJobs',
    EXPORT_CSV_DASHBOARD: 'exportCsvDashboard',
    EXPORT_CONTENT: 'exportContent',
    EXPORT_DOCUMENT_PDF: 'exportDocumentPdf',
    RENAME_RESOURCES: 'renameResources',
    MATERIALIZE_PRE_AGGREGATE: 'materializePreAggregate',
    CLEAN_QUERY_HISTORY: 'cleanQueryHistory',
    CLEAN_AI_USAGE_LEDGER: 'cleanAiUsageLedger',
    DOWNLOAD_ASYNC_QUERY_RESULTS: 'downloadAsyncQueryResults',
    SYNC_SLACK_CHANNELS: 'syncSlackChannels',
    GENERATE_SLACK_CHANNEL_SYNC_JOBS: 'generateSlackChannelSyncJobs',
    CHECK_FOR_STUCK_JOBS: 'checkForStuckJobs',
    CLEAN_DEPLOY_SESSIONS: 'cleanDeploySessions',
    MANAGED_AGENT_HEARTBEAT: 'managedAgentHeartbeat',
    CLEAN_EXPIRED_PREVIEWS: 'cleanExpiredPreviews',
    INGEST_PROJECT_CONTEXT: 'ingestProjectContext',
    COMPACT_USAGE_EVENTS: 'compactUsageEvents',
    BACKFILL_USAGE_QUERY_HISTORY: 'backfillUsageQueryHistory',
    POLL_EMAIL_WHITELABEL: 'pollEmailWhitelabelVerification',
    CLEAN_WAREHOUSE_CONNECT_CODES: 'cleanWarehouseConnectCodes',
    CLEAN_AGENT_CONNECTION_APPROVAL_REQUESTS: 'cleanAgentConnectionApprovalRequests',
    RECONCILE_PLAYGROUND_BUNDLES: 'reconcilePlaygroundBundles',
    BACKFILL_DEFAULT_USER_SPACES: 'backfillDefaultUserSpaces',
    LEARN_SANDBOX_COMMAND: 'learnSandboxCommand',
    ...EE_SCHEDULER_TASKS,
};
export const ALL_TASK_NAMES = Object.values(SCHEDULER_TASKS);
export const isSchedulerTaskName = (task) => includes(ALL_TASK_NAMES, task); // Had to use includes to avoid type error from Object.values().includes(string) related to union types https://github.com/microsoft/TypeScript/issues/46186
//# sourceMappingURL=schedulerTaskList.js.map